<template>
  <div class="mn606-chart common-border">
    <div class="common-border2">
      <el-row class="header">
        <el-col :span="24">
          <span class="sensor-name">{{ $t(name) }}:</span>
          <span class="value">{{ lastValue }}</span>
          <span class="unit-name">{{ unitName }}</span>
        </el-col>
      </el-row>
      <el-row class="center mt-15" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">{{ $t('安装状态') }}：{{ $t(status.install) }}</el-col>
        <el-col tag="span" :span="12">{{ $t('运行状态') }}：{{ $t(status.run) }}</el-col>
      </el-row>
      <el-row class="center" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">
          {{ $t('故障状态') }}：
          <span :class="status.faultClass">{{ $t(status.fault) }}</span>
        </el-col>
        <el-col tag="span" :span="12">
          {{ $t('报警状态') }}：
          <span :class="status.alarmClass">{{ $t(status.alarm) }}</span>
        </el-col>
      </el-row>
      <el-row class="center" v-if="gasTypeName" type="flex" align="middle">
        <el-col tag="span" :span="12">{{ $t('气体类型') }}：{{ gasTypeName }}</el-col>
        <el-col tag="span" :span="12"></el-col>
      </el-row>

      <div class="chart-box">
        <v-chart :options="opt" :autoresize="true"></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { tools } from '../utils';

export default {
  inject: ['time'],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      name: '',
      unit: '',
      unitName: '',
      lastValue: '',
      gasTypeName: '',
      status: {
        install: '',
        run: '',
        alarm: '',
        fault: ''
      },
      chart: [],
      faker: {
        sns: [],
        valueRangeList: {
          'CS-R': [0.1, 0.15],
          CO: [11, 15],
          H2S: [1, 2]
        },
        transform: {
          H2S: {
            code: 'CH3',
            value: 0,
            unitName: 'PPB',
            name: '沙林',
            gasTypeName: ''
          }
        }
      },
      opt: lineAreaStyle({
        color: '#009fe9',
        dataZoom: {
          start: 0,
          type: 'inside'
        },
        series: [
          {
            symbol: 'emptyCircle',
            areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') }
          }
        ],
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#009fe9'
            }
          }
        },
        grid: {
          top: 28,
          left: 30,
          right: 30,
          bottom: 20
        }
      })
    };
  },
  methods: {
    ...tools,
    modifyChart(data) {
      this.lastValue = data;
      if (this.chart.length >= 20) this.chart.shift();
      this.chart.push([this.time.begin, data]);
      this.opt.series[0].data = this.chart;
    },
    dataFaker(n) {
      if (this.faker.sns.includes(this.$route.params.sn)) {
        const { valueRangeList, transform } = this.faker;

        if (n.code in transform) {
          Object.assign(n, transform[n.code]);
        }

        if (n.code in valueRangeList) {
          const [min, max] = valueRangeList[n.code];
          Object.assign(this.opt.yAxis, {
            min,
            max
          });
        }
      }
    },
    setState(n) {
      Object.assign(this, {
        name: n.name,
        unit: n.unit,
        unitName: n.unitName,
        gasTypeName: n.gasTypeName
      });

      Object.assign(this.status, {
        install: this.pumpInstallText(n.installState),
        run: this.pumpRunText(n.runstate),
        fault: this.pumpFaultText(n.faultState),
        faultClass: this.pumpFaultClass(n.faultState),
        alarm: this.pumpAlarmText(n.alarmState),
        alarmClass: this.pumpAlarmClass(n.alarmState)
      });
    },
    setData(n) {
      this.setState(n);
      this.modifyChart(n.value);
    },
    setDataList(list, data) {
      this.setState(data);

      this.chart.push(...list.map(e => [e.beginTime, e.value]));
      this.opt.series[0].data = this.chart;
    }
  },
  watch: {
    data: 'setData'
  }
};
</script>

<style lang="scss">
.mn606-chart {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 4px;
  .header {
    font-size: 18px;
    background: #013c5d;
    padding: 12px 10px;
    border-radius: 4px;
    font-weight: bold;

    .sensor-name,
    .value,
    .unit-name {
      margin-right: 5px;
    }

    .unit-name {
      font-size: 12px;
    }
  }

  .common-border2 {
    height: 100%;
  }

  .center {
    padding: 5px;
    font-size: 16px;
    .el-col {
      text-align: center;
    }
  }
  .chart-box {
    height: calc(100% - 125px);
  }

  // 平板适配 (768px - 1024px)
  @media screen and (max-width: 1024px) {
    padding: 2px;

    .header {
      font-size: 14px;
      padding: 8px 6px;

      .unit-name {
        font-size: 10px;
      }
    }

    .center {
      padding: 3px;
      font-size: 12px;
    }

    .chart-box {
      height: calc(100% - 100px);
    }
  }

  // 1920分辨率150%缩放适配 (逻辑宽度1280px)
  @media screen and (width: 1280px) and (min-device-pixel-ratio: 1.5),
    screen and (width: 1280px) and (-webkit-min-device-pixel-ratio: 1.5) {
    padding: 2px;

    .header {
      font-size: 12px;
      padding: 6px 4px;

      .sensor-name,
      .value,
      .unit-name {
        margin-right: 3px;
      }

      .unit-name {
        font-size: 10px;
      }
    }

    .center {
      padding: 2px;
      font-size: 11px;
    }

    .chart-box {
      height: calc(100% - 85px);
    }
  }

  // 1920分辨率125%缩放适配 (逻辑宽度1536px)
  @media screen and (width: 1536px) and (min-device-pixel-ratio: 1.25),
    screen and (width: 1536px) and (-webkit-min-device-pixel-ratio: 1.25) {
    padding: 3px;

    .header {
      font-size: 15px;
      padding: 10px 8px;

      .sensor-name,
      .value,
      .unit-name {
        margin-right: 4px;
      }

      .unit-name {
        font-size: 11px;
      }
    }

    .center {
      padding: 4px;
      font-size: 13px;
    }

    .chart-box {
      height: calc(100% - 110px);
    }
  }

  // 1920平板适配 (逻辑宽度1920px)
  @media screen and (width: 1920px) {
    padding: 3px;

    .header {
      font-size: 15px;
      padding: 10px 8px;

      .sensor-name,
      .value,
      .unit-name {
        margin-right: 4px;
      }

      .unit-name {
        font-size: 11px;
      }
    }

    .center {
      padding: 4px;
      font-size: 13px;
    }

    .chart-box {
      height: calc(100% - 105px);
    }
  }
}
</style>
